import React, { useState,useEffect,useRef } from 'react';
 import dayjs from 'dayjs';
 import { postStar } from '../network/post_star';
 import { useNavigate } from 'react-router-dom';
 import { LoginRequiredModal } from '../components/loginpopup';
import ImagePopup from './ImagePopup';



// API 응답 구조를 가정하는 타입 (TypeScript가 아니므로 주석 처리)
// interface Item {
//   id: number;
//   image: string;
//   equipment_name: string; // 상품 브랜드/제조사
//   name: string;           // 상품명 (이미지에서 "Beanie", "Hood"에 해당)
//   need_star_count: number;
//   is_applied: boolean;
//   // ... 기타 필드
// }

const calculateDday = (futureDateString) => {
    // 1. 미래 날짜 파싱 (시간 정보 포함)
    const futureDate = dayjs(futureDateString);
    
    // 2. 오늘 날짜의 자정 (00:00:00)을 기준으로 설정 (정확한 일수 계산을 위해 시간 무시)
    const today = dayjs().startOf('day'); 
    
    // 3. 미래 날짜도 자정으로 설정하여 순수한 날짜 차이만 계산
    const futureDay = futureDate.startOf('day');

    // 4. 두 날짜의 차이 (일 단위) 계산
    // today.diff(futureDay, 'day')를 사용하면 음수가 나오므로, 
    // futureDay에서 today를 빼서 남은 일수를 구합니다.
    const daysDifference = futureDay.diff(today, 'day');

    if (daysDifference > 0) {
        // 미래 날짜일 경우: D-남은 일수
        return `D-${daysDifference}`;
    } else if (daysDifference === 0) {
        // 오늘 날짜일 경우: D-Day
        return 'D-Day';
    } else {
        // 이미 지난 날짜일 경우: D+지난 일수 (선택 사항)
        // 여기서는 D-Day로 표시하거나, 필요하다면 D+${Math.abs(daysDifference)}로 변경 가능
        return '종료됨'; 
    }
};

function DrawItemList({ items }) {
    const navigate = useNavigate();

  const [showLoginModal, setShowLoginModal] = useState(false);
      const [showErrorModal, setShowErrorModal] = useState(false);
          const [modalMessage, setModalMessage] = useState('');
  // 응모하기 버튼 클릭 핸들러 (실제 로직은 API 호출 등을 포함해야 함)
  const handleApplyClick = async (itemId, neededStars) => {
    const savedToken = localStorage.getItem('user');
            const storedUserObject = JSON.parse(savedToken);
    console.log(`아이템 ID ${storedUserObject.profile.item_count} 응모 시도. 필요 별: ${neededStars}개`);



    if(storedUserObject.username == 'temp'){
                        setShowLoginModal(true);

            }else if(storedUserObject.profile.item_count < neededStars){
                                             setModalMessage("보유중인 별 갯수가 부족합니다");
                    setShowErrorModal(true);
            }else{
              await postStar(itemId)
              setModalMessage("응모에 성공했습니다");
                    setShowErrorModal(true);
              window.location.reload();
            }
    // 여기에 실제 응모 API 호출 로직을 구현합니다.
  };

        const handleItemClick = (url) => {
        if (url) {
            window.open(url, '_blank');
        } else {

        }
    };

          const [isPopupOpen, setIsPopupOpen] = useState(false);

        const handleClosePopup = () => {
        setIsPopupOpen(false);
    };


  if (!items || items.length === 0) {
    return <div style={styles.loadingText}>응모 가능한 상품이 없습니다.</div>;
  }

  return (
    // 스크롤 가능한 목록 컨테이너 (모바일 화면 전체를 가정)
    <>
                      <LoginRequiredModal
                                                      isOpen={showLoginModal}
                                                      onClose={() => setShowLoginModal(false)}
                                                    />

                                                                    <ImagePopup 
                            isOpen={isPopupOpen} 
                            onClose={handleClosePopup} 
            
                            
                        />

                                                          {showErrorModal && (
                <ErrorDisplayModal
                    message={modalMessage}
                    onClose={() => setShowErrorModal(false)}
                />
            )}
    <div style={styles.listContainer}>
      {items.map((item, index) => (
        <div key={item.id || index} style={styles.itemCard}>
          
          {/* 1. 이미지 및 순서 태그 영역 */}
          <div style={styles.imageWrapper}>
            <img 
              src={item.image} 
              alt={item.name} 
              style={styles.itemImage} 
              onClick={() => handleItemClick(item.url)}
            />
            {/* D-4, D-5 같은 순서/태그 표시 (order 속성 사용 가정) */}
            <div style={styles.orderTag}>
              {calculateDday(item.appliable_at)}
            </div>
          </div>
          
          {/* 2. 상품 정보 영역 */}
          <div style={styles.infoArea}>
            <p style={styles.brandText}>{item.equipment_name}</p>
            <h2 style={styles.nameText}>{item.name}</h2>
          </div>
          
          {/* 3. 응모하기 버튼 */}
          <button 
            //onClick={() => handleApplyClick(item.id, item.applied_user_count)}
            onClick={() => setIsPopupOpen(true)}
            style={{
              ...styles.applyButton,
              // 이미 응모했다면 버튼 색상을 다르게 표시할 수 있음
              backgroundColor: item.is_applied ? '#666' : '#222',
            }}
            disabled={item.is_applied}
          >
            {item.is_applied ? '응모 완료' : `응모하기 ${item.applied_user_count}★`}
          </button>
          
          {/* 4. 옵션 메뉴 버튼 (세 개의 점) */}
          {/* <button style={styles.optionsButton}>
            •••
          </button> */}
        </div>
      ))}
    </div>
    </>
  );


  function ErrorDisplayModal({ message, onClose }) {
    return (
        <div style={errorModalStyles.backdrop}>
            <div style={errorModalStyles.content}>
                <p style={errorModalStyles.message}>{message}</p>
                <button onClick={onClose} style={errorModalStyles.confirmButton}>
                    확인
                </button>
            </div>
        </div>
    );
}
}

// ----------------------------------------------------
// 스타일 정의 (이미지와 유사하게)
// ----------------------------------------------------


const errorModalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    },
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '30px',
        width: '80%',
        maxWidth: '300px',
        textAlign: 'center',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '15px',
        color: '#ff4d4f', // 에러 강조색
    },
    message: {
        fontSize: '15px',
        marginBottom: '20px',
        color: '#333',
    },
    confirmButton: {
        width: '100%',
        padding: '10px',
        backgroundColor: '#ff4d4f',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        cursor: 'pointer',
    }
};

const styles = {
  listContainer: {
    padding: '10px 0',
    backgroundColor: '#ffffff',
  },
  itemCard: {
    padding: '20px 0',
    position: 'relative', // 옵션 버튼 배치를 위한 기준점
    marginBottom: '30px',
    borderBottom: '1px solid #f0f0f0', // 항목 구분선 (선택 사항)
    textAlign: 'center'
  },
  imageWrapper: {
    position: 'relative',

    padding: '0 10px', // 좌우 패딩
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '15px',
  },
  itemImage: {
    maxWidth: '70%', // 이미지 크기 제한 (중앙에 배치되도록)
    height: 'auto',
    display: 'block',
  },
  orderTag: {
    position: 'absolute',
    bottom: '0',
    // right: '10%', // 이미지 오른쪽 하단에 배치
    backgroundColor: '#555555',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  infoArea: {
    textAlign: 'center',
    // padding: '0 10vw',
  },
  brandText: {
    fontSize: '14px',
    color: '#666',
    margin: '0 0 2px 0',
  },
  nameText: {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '0 0 20px 0',
  },
  applyButton: {
    width: '70%',
    margin: '0 5%', // 좌우 5% 마진으로 가운데 배치
    padding: '15px 0',
    backgroundColor: '#222', // 이미지와 같은 짙은 회색
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  optionsButton: {
    position: 'absolute',
    top: '10px',
    // right: '5vw',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#aaa',
    fontSize: '24px',
    cursor: 'pointer',
    lineHeight: '0.5',
  },
  loadingText: {
    textAlign: 'center',
    padding: '50px',
    color: '#888',
  }
};

export default DrawItemList;